import { onReady } from '../lib/on-ready.js';

function initFaqs() {
    document.querySelectorAll('.faqAnswerFull').forEach((answer) => {
        answer.style.display = 'none';
    });

    document.querySelectorAll('.learn-more-expand').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            const hacksawAnswer = button.parentElement.querySelector('.faqAnswerHacksaw');
            const fullAnswer = button.parentElement.querySelector('.faqAnswerFull');

            hacksawAnswer.style.display = hacksawAnswer.style.display === 'none' ? 'block' : 'none';
            fullAnswer.style.display = fullAnswer.style.display === 'none' ? 'block' : 'none';
        });
    });
}

onReady(initFaqs);
